import type { PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody } from '@fukuri-admins/apis/client/gen/model';
import { formatDate } from '@fukuri-admins/utils/common/date';
import type { EditUserFormFieldValues } from '../schema';

type IGenerateRequest = (
  formValues: EditUserFormFieldValues,
  isPhoneNumberFieldVisible: boolean,
  isInvitee: boolean
) => PutApiV1ThreeLetterCodePartnerAdminsUsersUserIdBody;

/**
 * 利用者編集フォームの値から PUT API リクエストボディを生成する
 *
 * 電話番号フィールドが表示されているケース（isPhoneNumberFieldVisible。
 * logics/resolveFieldRequirements の判定結果）でのみ phone_number を送信する。
 * 空欄の場合は null を明示送信し、電話番号をクリアできるようにする。
 *
 * 【PEN-968 対応】家族招待ユーザー（is_invitee === true）は非課金対象のため、billable_from は null で送信する。
 * 通常ユーザーは必須バリデーション済みで Date 型に絞り込み済みのため、formatDate で送信する。
 *
 * @param formValues - フォームの入力値
 * @param isPhoneNumberFieldVisible - 電話番号フィールドの表示可否
 * @param isInvitee - 家族招待ユーザーかどうか（convertToPresentationProps で導出）
 * @returns PUT /partner_admins/users/:userId のリクエストボディ
 */
export const generateRequest: IGenerateRequest = (
  formValues,
  isPhoneNumberFieldVisible,
  isInvitee
) => ({
  user: {
    full_name: formValues.fullName,
    email: formValues.email,
    ...(isPhoneNumberFieldVisible ? { phone_number: formValues.phoneNumber || null } : {}),
    external_user_id: formValues.externalUserId ?? '',
    ...(formValues.password ? { password: formValues.password } : {}),
    ...(formValues.password && formValues.passwordConfirmation
      ? { password_confirmation: formValues.passwordConfirmation }
      : {}),
    // 家族招待ユーザー（is_invitee === true）は非課金対象で billable_from=null が正。
    // 通常ユーザーは必須バリデーション済みで Date 型に絞り込み済みのため、formatDate で送信する。
    billable_from: isInvitee
      ? null
      : formatDate({ date: formValues.billableFrom as Date, formatType: 'yyyy-MM-dd' }),
  },
});
